import React, { useState, useEffect, useRef } from "react";

//MUI Components
import Button from '@mui/material/Button';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getRidingPeriod, getLivraison, getPanier, getCommentaire, getShowPanier } from "../../../../store/selectors.js";

//global state : shopping state
import { shoppingStepSlice } from "../../../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../../../store/contratStepSlice.js";
import { commentaireSlice } from "../../../../store/commentaireSlice.js";
import { showPanierSlice } from "../../../../store/showPanierSlice.js";

//Utils functions
import { prepareDureeTexte } from '../../../../utils/calcul_duree.js'
import calculDuree from '../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrix, calcPrixDegressif } from "../../../../utils/calcul_prix.js" //parms : tarifs object, duree object

//created components
import ItemPanier from '../itempanier/ItemPanier.jsx'
import { getArticles } from '../../../../database/fetchApi.js';

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Panier({ articles }) {

    let [delta, setDelta] = useState(0);
    const refContainer = useRef();
    let deltaHeight = 0;


    useEffect(() => {

        if (refContainer.current) {
            deltaHeight = refContainer.current.scrollHeight - refContainer.current.offsetHeight;
            handleHeight(deltaHeight);
        }

        const handleResize = () => {

            if (refContainer.current) {
                deltaHeight = refContainer.current.scrollHeight - refContainer.current.offsetHeight;
                handleHeight(deltaHeight);
            }

        };

        window.addEventListener("resize", handleResize);
        // Cleanup: Remove event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };

    }, []);


    function handleHeight(height) {
        setDelta(height);
    }

    let panier = useSelector(getPanier);
    let periode = useSelector(getRidingPeriod);
    let globalComment = useSelector(getCommentaire);
    let showPanier = useSelector(getShowPanier);
    const lang = useSelector(getLang) //global state : language

    const dispatch = useDispatch();
    const nextStep = (event) => {
        dispatch(shoppingStepSlice.actions.nextShoppingStep());
        dispatch(showPanierSlice.actions.setShowPanier(false));
        //Manager mode
        dispatch(contratStepSlice.actions.nextContratStep());
    }

    function handleCommentChange(text) {
        dispatch(commentaireSlice.actions.setCommentaire(text));
    }

    function findArticle(id) {
        return articles.find((item) => item.id_article === id)
    }

    function getCumul() {
        let total = 0;
        let garantie = 0;
        panier.map((ligne) => {
            let currentArticle = findArticle(ligne.id_article);
            if (currentArticle) {
                total += (ligne.qte * calcPrixDegressif(currentArticle.Tarif, calculDuree(periode)))
                garantie += (ligne.qte * currentArticle.caution)
            }

        });

        return { total, garantie };
    }

    function closeModal() {
        dispatch(showPanierSlice.actions.setShowPanier(false));
    }

    return (
        <div className="panier-modal" ref={refContainer} >
            <CancelRoundedIcon className="panier-modal-close-icon" onClick={_ => closeModal()} />

            <div className="panier-modal-sticky"> {/* div pour passer en mode position relative pour gérer le bouton valid en sticky */}

                <div className="panier-modal-header">
                    <h3>{translator("Détails de votre panier", lang, "panierTitle")}</h3>
                    {delta > 30 ? <a href="#bt_valid"><p className="panier-modal-header-link">{translator("Valider", lang, "panierValider")}</p><ArrowDownwardIcon /> </a> : null}
                </div>

                <div className="panier-modal-lignes">
                    {panier.length > 0 ?
                        panier.map((ligne) => <ItemPanier key={ligne.id_article} article={findArticle(ligne.id_article)} duree={calculDuree(periode)} />)
                        :
                        <p className="panier-modal-lignes-vide">{translator("Votre panier est vide", lang, "panierVide")}</p>
                    }
                </div>

                <div className="panier-modal-sticky-bottom">
                    <div className="panier-modal-ligne-total">
                        <p>{translator("Prix total de votre panier :", lang, "panierTotal")}</p>
                        <h4>{getCumul().total},00€</h4>
                        <span className="panier-modal-ligne-total-blanche"></span>
                    </div>
                    <div className="panier-modal-ligne-garantie">
                        <p>{translator("valeur totale de la garantie demandée ", lang, "panierGarantie")}:</p>
                        <h4>{getCumul().garantie},00€</h4>
                    </div>

                    <div className="panier-modal-bottom">
                        <Alert severity="success">{translator("info : Les accessoires de location (casques, antivols, bombe anti-crevaison) vous seront fournis lors du retrait des vélos, au point de location choisi.", lang, "panierAlert")}</Alert>

                        <div className="panier-modal-bottom-commentaires">
                            <TextField
                                fullWidth
                                id="outlined-multiline-flexible"
                                label={translator("Commentaires", lang, "panierCommentaire")}
                                placeholder="facultatif"
                                /* defaultValue=" " */
                                value={globalComment}
                                onChange={e => handleCommentChange(e.target.value)}
                                multiline
                                maxRows={3}
                            />
                        </div>


                    </div>

                    <div className="panier-modal-sticky-bouton" id="bt_valid">

                        <Button
                            disabled={panier.length === 0}
                            className="bouton-valid-panier"
                            variant="contained"
                            onClick={nextStep}>
                            {translator("Valider le panier", lang, "panierValider2")}
                        </Button>
                    </div>
                </div>

            </div>
        </div>

    )
}




export default Panier